module.exports = vendors_df1049086bd904848f41;